import IRechargeLayer from "./IRechargeLayer";
import Player from "../../Models/Player";
import NetworkLogic from "../../Shared/NetworkLogic";
import UIManager from "../../Shared/UIManager";
import CommonToggleContainer from "../../Common/CommonToggleContainer";
import CQRCode from "../../Shared/CQRCode";
import { Global } from "../../Shared/Global";
import Utils from "../../Shared/Utils";

const LineTypes = {erc20: 1, omni: 2, trc20: 3}
const {ccclass, property} = cc._decorator;

@ccclass
export default class RechargeUSDTLayer extends IRechargeLayer {
    @property(cc.Node)
    nodeStep0: cc.Node = null
    
    @property(cc.Node)
    nodeStep1: cc.Node = null
    
    @property(cc.Node)
    nodeStep2: cc.Node = null
    
    @property(cc.Node)
    nodeStep3: cc.Node = null

    @property(cc.Label)
    labReminderAll: cc.Label = null

    @property(cc.Label)
    labReminderSeller: cc.Label = null
    
    @property(cc.Node)
    btnsNodeCreated: cc.Node = null
    
    @property(cc.Node)
    btnsNodeUnCreated: cc.Node = null
    
    @property(cc.Layout)
    lyContentSeller: cc.Layout = null

    @property(cc.Node)
    nodeTemplateItemSeller: cc.Node = null
    
    @property(CommonToggleContainer)
    toggleMoneyContainer: CommonToggleContainer = null

    @property(cc.Label)
    lbRate: cc.Label = null

    @property(cc.Label)
    lbMoneyRecharge: cc.Label = null

    @property(cc.Label)
    lbMoneyYuan: cc.Label = null
    
    @property(CommonToggleContainer)
    toggleChainTypeContainer: CommonToggleContainer = null

    @property(cc.Label)
    lbMoneyRecharge1: cc.Label = null

    @property(cc.Label)
    lbChainAddress: cc.Label = null

    @property(cc.Label)
    lbChainDescription: cc.Label = null

    @property(CQRCode)
    cqrCodeChainAddress: CQRCode = null

    @property(cc.EditBox)
    ebActualUSDT: cc.EditBox = null

    @property(cc.EditBox)
    ebFee: cc.EditBox = null

    private _sellerCfg = null
    private _orderInfo = null
    private _decimal = 0
    private _lineType = 0

    onLoad () {
        this.nodeTemplateItemSeller.parent = null
        this.labReminderAll.node.active = false
    }

    start () {
        NetworkLogic.getUsdtInfoConfig(function (data) {
            this.labReminderAll.string = data || ""
        }.bind(this))
    }

    onDisable () {
        this.nodeStep0.active = true
        this.nodeStep1.active = false
        this.nodeStep2.active = false
        this.nodeStep3.active = false
        this.lyContentSeller.node.destroyAllChildren()
    }

    onDestroy () {
        this.nodeTemplateItemSeller.destroy()
    }
    
    protected refreshData () {
        this.configs.forEach(cfg => {
            this.addSellerItem(cfg)
        });
        this.lyContentSeller.updateLayout()
        this.labReminderAll.node.active = this.configs.length > 0
    }

    private addSellerItem (cfg) {
        let node = cc.instantiate(this.nodeTemplateItemSeller)
        node.getChildByName("name").getComponent(cc.Label).string = cfg.clientChannelName
        node.getChildByName("rate").getComponent(cc.Label).string = `汇率：1USDT=${cfg.rate}元`
        node["rechargeCfg"] = cfg
        node.parent = this.lyContentSeller.node

        if (cfg.offerPercentage > 0) {
            cc.find("iconDiscount/discount", node).getComponent(cc.Label).string = "赠" + cfg.offerPercentage + "%"
        }else {
            cc.find("iconDiscount", node).active = false
        }
    }

    async onBtnClick (event, userData) {
        if (userData === "recharge") {
            // 需要补全资料
            if (Player.getPy("visitorFillInfoTime").indexOf("3") !== -1 && Player.getPy("userType") === 2) {
                // 打开界面
                let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
                hallUI.openChildUI(hallUI.pfbLoginCompleteInformation);
                return
            }

            this._orderInfo = await this.getLatestUsdtOrder()
            this._decimal = await this.getUsdtDecimals()
            
            // 存在未完成的订单，则跳转到对应的渠道
            if (this._orderInfo) {
                for (let i = 0; i < this.configs.length; i++) {
                    const cfg = this.configs[i];
                    if (cfg.id === this._orderInfo.depositorTypeId) {
                        this._sellerCfg = cfg
                        break
                    }
                }
                if (!this._sellerCfg) {
                    UIManager.showTipUI("充值渠道不存在，请联系客服")
                    return
                } 
            }else {
                this._sellerCfg = event.target.parent.rechargeCfg
            }
            
            this.nodeStep0.active = false
            this.nodeStep1.active = true
            this.initData()
            this.setDataByOrderInfo()
        }else if (userData === "createOrder") {
            if (!this.lbMoneyRecharge.string) {
                UIManager.showToastUI("请选择充值金额", Global.ToastType.Warnning)
                return
            }
            UIManager.showLoadingUI()
            NetworkLogic.createUSDTOrder({
                "id": this._sellerCfg.id,
                "usdtChargeNum": parseFloat(this.lbMoneyRecharge.string),
                "usdtRate": this._sellerCfg.rate,
            }, function (data) {
                UIManager.hideLoadingUI()
                this._orderInfo = data
                this.setDataByOrderInfo()
                this.nodeStep1.active = false
                this.nodeStep2.active = true
            }.bind(this))
        }else if (userData === "created") {
            this.nodeStep1.active = false
            this.nodeStep2.active = true
        }else if (userData === "cancelOrder") {
            UIManager.showConfirmUI("确定取消订单吗？", function () {
                UIManager.showLoadingUI()
                NetworkLogic.cancelLatestUsdtOrder(this._orderInfo.id, function () {
                    UIManager.hideLoadingUI()
                    this.nodeStep1.active = false
                    this.nodeStep0.active = true
                }.bind(this))
            }.bind(this))
        }else if (userData === "back") {
            this.nodeStep1.active = false
            this.nodeStep0.active = true
        }else if (userData === "copyAddress") {
            Utils.copyText(this.lbChainAddress.string)
            UIManager.showToastUI("复制成功", Global.ToastType.OK)
        }else if (userData === "saveCode") {
            Utils.saveNodeImageToAlbum(this.cqrCodeChainAddress.node, "usdt_address.png", function (success) {
                if (success) {
                    UIManager.showToastUI("保存图片成功", Global.ToastType.OK)
                }else {
                    UIManager.showTipUI("保存图片失败。请前往手机设置页面，打开本应用存储图片的权限")
                }
            }.bind(this))
        }else if (userData === "copyUSDT") {
            Utils.copyText(this.lbMoneyRecharge1.string)
            UIManager.showToastUI("复制成功", Global.ToastType.OK)
        }else if (userData === "preStep") {
            this.nodeStep2.active = false
            this.nodeStep1.active = true
        }else if (userData === "nextStep") {
            this.nodeStep2.active = false
            this.nodeStep3.active = true
        }else if (userData === "preStep1") {
            this.nodeStep3.active = false
            this.nodeStep2.active = true
        }else if (userData === "finish") {
            // if (!this.ebActualUSDT.string) {
            //     UIManager.showToastUI("请填写实际到账USDT金额", Global.ToastType.Warnning)
            //     return
            // }
            // if (!this.ebFee.string) {
            //     UIManager.showToastUI("请填写提币花费手续费金额", Global.ToastType.Warnning)
            //     return
            // }
            // if (parseFloat(this.ebFee.string) > 50) {
            //     UIManager.showToastUI("手续费0-50USDT", Global.ToastType.Warnning)
            //     return
            // }
            UIManager.showLoadingUI()
            NetworkLogic.submitUSDTOrder({
                "chargeVirtualAddress": this.lbChainAddress.string,         // 充值地址
                "chargeVirtualServiceCharge": this.ebFee.string || 0,       // 手续费
                "chargeVirtualType": this._lineType,                        // 虚拟币充值的地址类型：1. erc20 2.omni 3.trc20
                "id": this._sellerCfg.id,                                   // 充值配置id
                "orderId": this._orderInfo.id,                              // 订单id
                "usdtChargeNum": this._orderInfo.chargeVirtualNum,          // usdt个数
                "usdtRate": this._sellerCfg.rate                            // 汇率
            }, function () {
                UIManager.hideLoadingUI()
                UIManager.showToastUI("订单已提交，请耐心等待", Global.ToastType.OK)
                this.nodeStep3.active = false
                this.nodeStep2.active = false
                this.nodeStep0.active = true
            }.bind(this))
        }
    }

    onSelectToggle (toggle, userData) {
        if (userData === "money") {
            // 是否可以重复选择（0是1否）
            if (this.toggleMoneyContainer.checkedToggle.userData["isopenRepeatInput"] === 0) {
                this.lbMoneyRecharge.string = (this.lbMoneyRecharge.string ? parseInt(this.lbMoneyRecharge.string) : 0) + toggle.userData.QuickSelectionAmount + this._decimal
            }else {
                this.lbMoneyRecharge.string = toggle.userData.QuickSelectionAmount + this._decimal
            }

            // js的float有bug，可能出现多位小数的情况
            let tail = this._decimal.toString().split(".")[1]
            let count = tail ? tail.length : 0
            this.lbMoneyRecharge.string = parseFloat(this.lbMoneyRecharge.string).toFixed(count)
            let usdt = parseFloat(this.lbMoneyRecharge.string)
            let money = parseFloat((usdt * this._sellerCfg["rate"]).toFixed(2))
            this.lbMoneyYuan.string = `最终充值到账金额为：${money}（${usdt}USDT*当前汇率${this._sellerCfg["rate"]}元）`
        }else if (userData === "lineType") {
            this._lineType = LineTypes[toggle.userData]
            this.lbChainAddress.string = this._sellerCfg[toggle.userData + "Url"]
            this.lbChainDescription.string = this._sellerCfg[toggle.userData + "Description"]
            this.cqrCodeChainAddress.string = this._sellerCfg[toggle.userData + "Url"]
        }
    }

    private getLatestUsdtOrder (): Promise <any> {
        return new Promise <any> (resolve => {
            UIManager.showLoadingUI()
            NetworkLogic.getLatestUsdtOrder(function (data) {
                UIManager.hideLoadingUI()
                if (data && data.status === "2" && !data.chargeVirtualAddress) {
                    UIManager.showConfirmUI("您有尚未完成的订单，是否继续？", function () {
                        resolve(data)
                    }.bind(this), "继续", function () {
                        UIManager.showLoadingUI()
                        NetworkLogic.cancelLatestUsdtOrder(data.id, function () {
                            UIManager.hideLoadingUI()
                            resolve(null)
                        }.bind(this))
                    }.bind(this), "取消订单")
                }else {
                    resolve(null)
                }
            }.bind(this))
        })
    }

    private getUsdtDecimals (): Promise <any> {
        return new Promise <any> (resolve => {
            UIManager.showLoadingUI()
            NetworkLogic.getUsdtDecimals(function (data) {
                UIManager.hideLoadingUI()
                resolve(data)
            }.bind(this), function () {
                UIManager.showChangeDomainUI(async function () {
                    let data = await this.getUsdtDecimals()
                    data && resolve(data)
                }.bind(this))
            }.bind(this))
        })
    }

    private initData () {
        // 配置金额
        this.toggleMoneyContainer.node.removeAllChildren()
        this.toggleMoneyContainer.node.destroyAllChildren()
        let fixedAmount = JSON.parse(this._sellerCfg.fixedAmount)
        fixedAmount.forEach(item => {
            this.toggleMoneyContainer.addDefaultToggle(item.QuickSelectionAmount, item)
        });
        
        this.lbRate.string = `汇率：1USDT=${this._sellerCfg.rate}元`
        this.lbMoneyRecharge.string = ""
        this.lbMoneyYuan.string = "最终充值到账金额为："
        this.labReminderSeller.string = this._sellerCfg.remark
        this.ebActualUSDT.string = ""
        this.ebFee.string = ""
        this.btnsNodeCreated.active = false
        this.btnsNodeUnCreated.active = true
        this.toggleMoneyContainer.enabled = true

        // 第二步链类型
        this.nodeStep2.active = true // 不设置为true，toggle会有bug，所以初始化完成后再设置回false
        this.lbChainAddress.string = ""
        this.toggleChainTypeContainer.node.removeAllChildren()
        this.toggleChainTypeContainer.node.destroyAllChildren()
        this._sellerCfg.erc20Url && this.toggleChainTypeContainer.addDefaultToggle("ERC20", "erc20")
        this._sellerCfg.omniUrl && this.toggleChainTypeContainer.addDefaultToggle("OMNI", "omni")
        this._sellerCfg.trc20Url && this.toggleChainTypeContainer.addDefaultToggle("TRC20", "trc20")
        this.nodeStep2.active = false
    }

    private setDataByOrderInfo () {
        if (!this._orderInfo) return
        this.btnsNodeCreated.active = true
        this.btnsNodeUnCreated.active = false
        this.toggleMoneyContainer.enabled = false
        this.lbMoneyRecharge.string = this._orderInfo.chargeVirtualNum
        this.lbMoneyRecharge1.string = this._orderInfo.chargeVirtualNum
        let money = parseFloat((this._orderInfo.chargeVirtualNum * this._sellerCfg["rate"]).toFixed(2))
        this.lbMoneyYuan.string = `最终充值到账金额为：${money}（${this._orderInfo.chargeVirtualNum}USDT*当前汇率${this._sellerCfg.rate}元）`
    }
}
